module.exports = __webpack_public_path__ + "static/media/lmsELearning.5002793f.jpg";